"use client";
import { jsx as e, Fragment as o } from "react/jsx-runtime";
import { createSvgIcon as t } from "@mui/material/utils";
const l = t(
  /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(
    "path",
    {
      d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }),
  "KmxRadioButtonStroked"
);
export {
  l as default
};
